// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Rvjf","modalForm":"UpgradeEpcsModal_modalForm__3Whcv","modalFooter":"UpgradeEpcsModal_modalFooter__3ADK-"};